import AppRoutes from './AppRoutes';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from 'react';
import "./index.css";
import ErrorBoundary from './ErrorBoundary';

function App() {

  // in App.jsx or a top-level component
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        // Page was restored from bfcache — force a full reload so
        // React Router / ProtectedRoutes actually re-evaluates auth.
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ErrorBoundary>
      <ToastContainer style={{
        error: {
          duration: 3000,
          style: {
            backgroundColor: '#e3e334',
            borderRadius: '30px',
            color: '#fff'
          },
        },
      }}
        closeButton={false}
        position="bottom-center" autoClose={3000} theme="colored" hideProgressBar={true} pauseOnHover={false} limit={3} />
    </div>
  );
}

export default App;